import { connect, Dispatch } from 'react-redux';
import { IRootState } from 'redux/root_reducer';

import VintageNewArrivalsPage from 'components/pages/VintageNewArrivalsPage/VintageNewArrivalsPage';
import { getNewArrivals, NewArrivalsReduxState } from 'redux/modules/VintageNewArrivals';

const mapStateToProps = (state: IRootState): NewArrivalsReduxState => { // This should probably be aliased as props instead of state
    const { isFetchingNewArrivals, newArrivals } = state.NewArrivalsReducer;
    return { isFetchingNewArrivals, newArrivals };
};

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
    return { getNewArrivals: () => dispatch<any>(getNewArrivals()) };
};

export default connect<any, {},  any>(mapStateToProps, mapDispatchToProps)(VintageNewArrivalsPage);



// WEBPACK FOOTER //
// ./src/containers/pages/VintageNewArrivalsPage/VintageNewArrivalsPage.tsx